import * as yup from 'yup';

const SupplierSchema = yup.object().shape({
  name: yup.string().required('Vui lòng nhập tên'),
  email: yup.string().email('Email không hợp lệ').required('Vui lòng nhập email'),
  phoneNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, 'Số điện thoại không hợp lệ')
    .required('Vui lòng nhập số điện thoại'),
  address: yup.object().shape({
    street: yup.string().required('Vui lòng nhập địa chỉ'),
    ward: yup.string().required('Vui lòng nhập phường/xã'),
    city: yup.string().required('Vui lòng nhập tỉnh/thành phố'),
  }),
});

export { SupplierSchema };
